export default __webpack_public_path__ + "static/grouped-column-3ff7a3b7ddf305507c7aeac4046bed57.png";